import { Badge as MatBadge, BadgeProps as MuiBadgeProps, WithStyles, withStyles } from '@material-ui/core';

import { styles } from './Badge.styles';

type BadgeProps = MuiBadgeProps & WithStyles<typeof styles>;

export const Badge = withStyles(styles)((props: BadgeProps) => <MatBadge {...props} color="primary" />);
